import { shallowEqual, useSelector } from "react-redux";

/**
 * Roles del backoffice (contrato con el backend, user.utils.js):
 *  - admin  → puede escribir (sesiones, control de la dinámica, usuarios).
 *  - viewer → solo lectura (cliente): ve KPIs y respuestas y descarga informes.
 */
export const ROLES = {
	ADMIN: "admin",
	VIEWER: "viewer"
};

export const ROLE_LABELS = {
	[ROLES.ADMIN]: "Administrador",
	[ROLES.VIEWER]: "Solo lectura (cliente)"
};

export function roleLabel(role) {
	return ROLE_LABELS[role] || role || "—";
}

/** Usuario autenticado (lo que devuelve POST /api/user/signin → user). */
export const selectAuthUser = store => store.authentication?.user || null;

/** Solo el rol 'admin' puede escribir. Cualquier otro valor (o ausencia) se trata como lectura. */
export const selectIsAdmin = store => selectAuthUser(store)?.role === ROLES.ADMIN;

export function useAuthUser() {
	return useSelector(selectAuthUser, shallowEqual);
}

export function useIsAdmin() {
	return useSelector(selectIsAdmin);
}
